<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
  >
      <v-card>
        <v-toolbar dark dense color="primary">
          <v-btn icon @click="handleClose" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark @click.native="handleSave">
              <v-icon>save</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
    <v-progress-linear :indeterminate="true" v-if="isLoading"/>

        <!-- Form comes here -->
        <slot>
          The form should come here
        </slot>

      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    dialog: Boolean,
    handleSave: Function,
    handleClose: {
      type: Function,
      required: true,
    },
    isLoading: Boolean,
  },
}
</script>
<style scoped>
  .v-progress-linear {
    margin: 0 !important;
  }
</style>
